/* Luv Secret — currency swap for product body_html straps and other static £ amounts.

   When a visitor is on EUR or USD, any static "£N" or "£N.NN" inside designated
   regions is rewritten to the active currency. Two strategies:

   A) Threshold anchors (75/120/180): swap to the fixed three-currency table.
   B) Other amounts: convert using Shopify's exposed currency rate and round to
      .90 (EUR) or .99 (USD). The rate matches Shopify Markets so the result is
      consistent with checkout prices.

   This script is idempotent (safe to run multiple times) and only runs once
   active currency != GBP.
*/

(function () {
  'use strict';

  if (!window.Shopify || !window.Shopify.currency) return;
  var active = window.Shopify.currency.active || 'GBP';
  if (active === 'GBP') return; // GBP visitors see the source text unchanged

  var rate = parseFloat(window.Shopify.currency.rate || '1');
  if (!rate || rate === 1) return; // no conversion needed

  var symbols = { GBP: '\u00A3', EUR: '\u20AC', USD: '$' };
  var sym = symbols[active] || '\u00A3';

  // Fixed anchors (must match snippets/luv-money.liquid)
  var ANCHORS = {
    75:  { EUR: '\u20AC90',  USD: '$75'  },
    120: { EUR: '\u20AC145', USD: '$150' },
    180: { EUR: '\u20AC215', USD: '$225' }
  };

  // Round to nearest whole number (per Luv brand direction: premium round price).
  function formatAmount(gbpAmt) {
    var converted = gbpAmt * rate;
    return sym + Math.round(converted);
  }

  // Match £NN or £NN.NN as a whole token (not preceded by alpha or digit)
  var poundRe = /(^|[^A-Za-z0-9])\u00A3(\d+(?:\.\d{1,2})?)(?!\d)/g;

  function rewriteText(text) {
    return text.replace(poundRe, function (full, lead, num) {
      var n = parseFloat(num);
      // anchor swap
      if (ANCHORS[n] && ANCHORS[n][active]) {
        return lead + ANCHORS[n][active];
      }
      // generic conversion
      return lead + formatAmount(n);
    });
  }

  // Walk text nodes inside designated regions only — never touch the whole page.
  // Regions:
  //   - .product__description, .rte (Dawn defaults)
  //   - .luv-pdp-* content blocks (theme custom)
  //   - .luv-candles-* content blocks
  //   - .luv-faq__answer
  //   - product description / story sections
  var SELECTORS = [
    '.product__description',
    '.rte',
    '.luv-pdp-hero__copy',
    '.luv-pdp-inline-atc__copy',
    '.luv-pdp-cross__copy',
    '.luv-pdp-routine-builder',
    '.luv-candles-rituals',
    '.luv-candles-ribbon',
    '.luv-candles-extras',
    '.luv-faq__answer',
    '.luv-final-cta',
    '.luv-final-cta-v2',
    '.luv-offers-hero',
    '.luv-offers-hero-v2',
    '.luv-ritual-boxes',
    '.luv-ritual-deepbox',
    '.luv-ritual-howto',
    '.luv-all-rituals',
    '[data-luv-currency-swap]'
  ];

  function rewriteRoot(root) {
    if (!root || root.dataset && root.dataset.luvCurrencySwapDone === '1') return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    var changed = false;
    var stack = [];
    while ((node = walker.nextNode())) stack.push(node);
    stack.forEach(function (n) {
      var v = n.nodeValue;
      if (!v || v.indexOf('\u00A3') === -1) return;
      var nv = rewriteText(v);
      if (nv !== v) { n.nodeValue = nv; changed = true; }
    });
    if (root.dataset) root.dataset.luvCurrencySwapDone = '1';
  }

  function run() {
    // CSS selector list -> rewrite
    document.querySelectorAll(SELECTORS.join(',')).forEach(rewriteRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run after section reloads (Shopify section rendering API)
  document.addEventListener('shopify:section:load', run);

  // Public hook for late-loaded content
  window.LuvCurrencySwap = { run: run, rewriteText: rewriteText, active: active, rate: rate };
})();
